import React from "react";
import "../styles/PrivacyPolicy.css";

import { useTranslation } from 'react-i18next';

export default function PrivacyPolicy() {
	const { t } = useTranslation();
	return (

		<div className="privacypolicy">
			<h1>{t('privacy.title')}</h1>
			<p><strong>{t('privacy.lastUpdate')} :</strong> {t('privacy.date')}</p>

			<p>{t('privacy.welcome')} <strong>zeldle.xyz</strong>.</p>

			<p>
				{t('privacy.intro')}
			</p>

			<h2>{t('privacy.section1Title')}</h2>
			<p>
				{t('privacy.section1Text')}
			</p>

			<h2>{t('privacy.section2Title')}</h2>
			<p>
				{t('privacy.section2Text')}
			</p>
			<p>
				{t('privacy.section2Link')}<br />
				👉 <a href="https://policies.google.com/technologies/ads" target="_blank" rel="noopener noreferrer">
				https://policies.google.com/technologies/ads
				</a>
			</p>

			<h2>{t('privacy.section3Title')}</h2>
			<p>
				{t('privacy.section3Text1')}
			</p>
			<p>
				{t('privacy.section3Text2')}<br />
				👉 <a href="https://adssettings.google.com" target="_blank" rel="noopener noreferrer">
				https://adssettings.google.com
				</a>
			</p>

			<h2>{t('privacy.section4Title')}</h2>
			<p>
				{t('privacy.section4Text')}
			</p>

			<h2>{t('privacy.section5Title')}</h2>
			<p>
				{t('privacy.section5Text')}<br />
				📧 <a href="mailto:contact@zeldle.xyz">contact@zeldle.xyz</a>
			</p>
		</div>
	);
}
